import { Component, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { OrderService } from '../../services/order/order.service';
import { Order } from '../../models/order/order.model';
import { ProductService } from '../../services/product/product.service';
import { Product } from '../../models/products/product.model';
import { BrandService } from '../../services/brand/brand.service';
import { Brand } from '../../models/brand/brand-model';
import { CustomerService } from '../../services/customer/customer.service';
import { Customer } from '../../models/customer/customer-model';
import { EnumDropDown } from '../../models/shared/enum-dropdown'
import { OrderDetail } from '../../models/order/order-detail.model';
import { OrderViewModel, PrintOrdersList } from '../../models/order/order-view-model.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RatingService } from '../../services/rating/rating.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Coupon } from '../../models/coupons/coupon-model';
import { ReadMoreComponent } from '../../shared-components/read-more/read-more.component';
import { Country } from '../../models/country/country-model';
import { State } from '../../models/state/state-model';
import { StateService } from '../../services/state/state.service';
import { CountryService } from '../../services/country/country.service';
import { City } from '../../models/city/city-model';


import { dataUrl } from 'angular-file/file-upload/fileTools';
@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.css']
})
/** order-detail component*/
export class OrderDetailComponent {
  public orderDetail: PrintOrdersList;
  public unVerfiedProducts: number[] = [];
  public ProductList: Product[];
  public productDetail = new Product();
  public ProductToAdd: OrderDetail;
  public vendorProductList: Product[];
  public customerList: Customer[]=[];
  public brandtList: Brand[];
  public orderStatuses: EnumDropDown[];
  public purchasOrderStatuses: EnumDropDown[];
  public orderDetailStatuses: EnumDropDown[];
  public productidDistinct: number[];
  public ProductType: string;
  public customer: Customer;
  public productName: string;
  public showSuggestions: boolean = false;
  public isProductToAddVisibile: boolean;
  public addnewProduct: boolean = false;
  public subTotal: number;
  public total: number;
  public orderDetailPrintComponent: string;
  public discountRow: string;
  public product: Product;
  countryList: Country[] = [];
  mainStateList: State[] = [];
  mailingStateList: State[] = [];
  mainCityList: City[] = [];
  mailingCityList: City[] = [];
  paymentSaleAmount: number = 0;
  public customerOrderAdress = new Order();
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  /** order-detail ctor */
  constructor(private readonly orderService: OrderService,
    private _avRoute: ActivatedRoute, private _router: Router,
    private readonly ProductService: ProductService,
    private readonly BrandService: BrandService,
    private readonly CustomerService: CustomerService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef,
    private modalService: BsModalService,
    private readonly ratingService: RatingService, private readonly rolePermissionService: RolePermissionService, private readonly countryService: CountryService,
    private readonly stateService: StateService) {
    this.addnewProduct = false;
    this.orderDetail = new PrintOrdersList();
    this.orderDetail.order = new Order();
    this.orderDetail.customer = new Customer();
    this.ProductToAdd = new OrderDetail();
    this.orderDetail.coupon = new Coupon();

    this.rolePermissionService.GetRolePermissions("purchaseorderview").subscribe(
      data => {

        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            if (this._avRoute.snapshot.params["id"]) {
              this.GetOrderDetail(this._avRoute.snapshot.params["id"]);
            }
            
            
            this.ProductToAdd.vendorID = 0;
            this.ProductToAdd.productID = 0;
            this.GetCountries();
            this.ProductList = [];
            this.customerList = [];
            this.brandtList = [];
            this.orderDetailStatuses = [];
            this.getOrderStatuses();
            this.getOrderDetailStatuses();
            this.getProcessOrderStatuses();
            this.ProductType = "Recent";
            this.discountRow = '';
            this.isProductToAddVisibile = false;
          }
          else {
            this._router.navigate(["/order-list"]);
          }
        }
        else {
          this._router.navigate(["/order-list"]);
        }
      }
    )
  }
  GetCountries() {
    this.countryService.getCountries().subscribe(
      data => {
        this.countryList = data;
      });
  }
  GetOrderDetail(id: string) {
    this.orderService.GetOrderDetailByOrder(id).subscribe(
      data => {
       // this.getVendors();
        this.orderDetail = data;
        //this.getBrands();        
        //this.getProdducts(this.ProductType);
        this.subTotal = 0;
        this.total = 0;
        this.paymentSaleAmount = 0;
        this.calculateSubtotalPrint(data);
      });
  }


  GetOrderDetailByID(id: number) {
    this.orderService.GetOrderDetailByID(id).subscribe(
      data => {
        this.ProductToAdd = data;
      }
    )
  }
  ifProductExist(productID: number) {
    return (this.ProductList.find(i => i.productID == productID) == undefined);
  }
  ifVendorExist(vendorID: number) {
    return (this.customerList.find(i => i.customerID == vendorID) == undefined);
  }
  ifBrandExist(brandID: number) {
    return (this.brandtList.find(i => i.brandID == brandID) == undefined);
  }
  getProdducts(type: string) {
    this.ProductType = type;
    this.ProductList = [];
    this.productidDistinct = [];
    for (var i = 0; i < this.orderDetail.orderDetails.length; i++) {
      if (this.productidDistinct.filter(d => d == this.orderDetail.orderDetails[i].productID).length == 0) {
        this.productidDistinct.push(this.orderDetail.orderDetails[i].productID);
      }
    }
    for (var i = 0; i < this.productidDistinct.length; i++) {
      this.ProductService.GetProductById(this.productidDistinct[i]).subscribe(
        data => {
          this.ProductList.push(data);
        });
    }
  }
  getVendors() {
    if (this.customerList.length == 0) {
      this.CustomerService.getVendors().subscribe(
        data => {
          this.customerList = data.filter(i => i.isActive == true);

        }
      )
    }
  }
  hideAddPrductDiv() {
    this.isProductToAddVisibile = false;
    this.ProductToAdd = new OrderDetail();
    this.ProductToAdd.vendorID = 0;
    this.ProductToAdd.productID = 0;
  }
  getBrands() {
    this.BrandService.getBrand().subscribe(
      data => {
        this.brandtList = data;
      }
    )
  }
  getOrderStatuses() {
    this.orderService.GetOrderStatuses().subscribe(
      data => {
        this.orderStatuses = data;
      }
    )
  }
  openCustomerModal(template: TemplateRef<any>, id) {
    this.ratingService.getCustomerInfo(id).subscribe(
      data => {
        if (data) {
          this.customer = data;
          if (this.customer.profileImagePath == null) {
            this.customer.profileImagePath = "http://ssl.gstatic.com/accounts/ui/avatar_2x.png";
          }
          this.modalRef = this.modalService.show(template, this.config);
        }
      }
    )
  }
  openProductModal(productTemplate: TemplateRef<any>, id) {
    this.ProductService.GetProductById(id).subscribe(
      data => {
        if (data) {
          this.productDetail = data;
          this.modalRef = this.modalService.show(productTemplate, this.config);
        }
      }
    )
  }
  getProcessOrderStatuses() {
    this.orderService.GetPurchaseOrderStatuses().subscribe(
      data => {
        this.purchasOrderStatuses = data;
      }
    )
  }
  getOrderDetailStatuses() {
    this.orderService.GetOrderDetailStatuses().subscribe(
      data => {
        data.pop();
        this.orderDetailStatuses = data;
      }
    )
  }


  isValidOrder(orderID: number) {
    return this.unVerfiedProducts.filter(i => i == orderID).length > 0;
  }
  changeOrderDetailStatus(statusID: string, orderDetailID: number) {
    this.orderService.ChangeOrderDetailStatus(orderDetailID, statusID).subscribe(
      data => {
        
        if (data == true) {
          this.GetOrderDetail(this._avRoute.snapshot.params["id"]);
          this.toastr.success("Order# " + orderDetailID + " has been updated.", "Success");
        }
        else {
          this.toastr.error("Error in Order# " + orderDetailID + " updation.", "Error");
        }
      }
    )
  }
  ChangeOrderStatus(orderId: string, orderStatusId: number) {
    this.orderService.ChangeOrderStatus(orderId, orderStatusId).subscribe(
      data => {
        
        if (data == true) {
          this.toastr.success("Order detail has been updated.", "Success");
          this.GetOrderDetail(this._avRoute.snapshot.params["id"]);
        }
        else {
          this.toastr.error("Error in Order detail updation.", "Error");
        }
      }
    )
  }
  VerifyOrderToPO(orderID: string) {
    this.orderService.VerifyOrderToPO(orderID).subscribe(
      data => {
        this.unVerfiedProducts = data;
        if (data.length == 0) {
          this._router.navigate(["/purchase-order-list"]);
        }
        else {
          this.toastr.error("Order is incomplete", "Error")
        }
        this._router.navigate(["/purchase-order-list"]);
      }
    );
  }
  GetProductByVendor(vendorID: number) {
    this.ProductToAdd.vendorID = vendorID;
    this.ProductService.GetProductByVendor(vendorID).subscribe(data => {
      this.vendorProductList = data.filter(i => i.isActive == true && i.productStatusId == 4);
      
    });
  }
  productToAddIDChanged(value: any, name: any, price: number = 0, commissionPrice: number=0) {
    this.showSuggestions = false;
    this.ProductToAdd.productID = value;
    this.productName = name;
    if (this.addnewProduct) {
      this.ProductToAdd.price = price;
      this.ProductToAdd.commissionPrices = commissionPrice;
    }
  }
  addProduct() {
    this.addnewProduct = false;
    if (this.ProductToAdd.quantity > 0 &&
      this.ProductToAdd.productID != 0 &&
      this.ProductToAdd.productID != undefined &&
      this.ProductToAdd.price > 0
    ) {
      this.orderService.AppendOrder(this.ProductToAdd, this._avRoute.snapshot.params["id"]).subscribe(data => {
        if (data) {
          this.toastr.success('Product has been added', 'Success');
          this.GetOrderDetail(this._avRoute.snapshot.params["id"]);
          this.ProductToAdd = new OrderDetail();
          this.ProductToAdd.vendorID = 0;
          this.ProductToAdd.productID = 0;
        }
      });
    }
    else {
      this.toastr.error('All Fields are required.', 'Error');
    }
    this.isProductToAddVisibile = false;
  }
  addNewProduct() {
    if (this.ProductToAdd.quantity > 0 &&
      this.ProductToAdd.productID != 0 &&
      this.ProductToAdd.productID != undefined &&
      this.ProductToAdd.price > 0
    ) {
      
      this.orderService.AppendOrder(this.ProductToAdd, this._avRoute.snapshot.params["id"]).subscribe(data => {
        if (data) {
          this.toastr.success('New Product has been added', 'Success');
          this.GetOrderDetail(this._avRoute.snapshot.params["id"]);
          this.ProductToAdd = new OrderDetail();
          this.ProductToAdd.vendorID = 0;
          this.ProductToAdd.productID = 0;
        }
      });
    }
    else {
      this.toastr.error('All Fields are required.', 'Error');
    }
    this.isProductToAddVisibile = false;
    this.addnewProduct = false;
  }
  createDuplicateOrder(orderDetail: OrderDetail) {
    this.getVendors();
    this.isProductToAddVisibile = true;
    this.addnewProduct = false;
    this.ProductToAdd.isNewProduct = false;;
    this.ProductToAdd.quantity = orderDetail.quantity;
    this.ProductToAdd.price = orderDetail.price;
    this.ProductToAdd.orderID = orderDetail.orderID;
    this.ProductToAdd.commissionType = orderDetail.commissionType;

    this.ProductToAdd.commissionPrices = 0;//orderDetail.commissionPrices;
    this.ProductToAdd.referenceOrderDetailID = orderDetail.orderDetailID;
    //this.orderService.CancelOrderDetail(orderDetail.orderDetailID).subscribe(
    //  data => {
    //    if (data == true) {
    //      this.toastr.success('Order detail', 'Success');
    //    }
    //    else {
    //    }
    //  }
    //);
  }
  addProductToOrder() {
    this.getVendors();
    this.isProductToAddVisibile = true;
    this.addnewProduct = true;
    this.ProductToAdd.quantity = 0;
    this.ProductToAdd.price = 0;
    this.ProductToAdd.isNewProduct = true;
    this.ProductToAdd.orderID = this.orderDetail.order.orderID;
    this.ProductToAdd.commissionType = 0;

    this.ProductToAdd.commissionPrices = 0;//orderDetail.commissionPrices;
    this.ProductToAdd.referenceOrderDetailID = 0;

  }


  getCustomerAdressByOrder(customerTemplate: TemplateRef<any>, Id) {
    this.orderService.GetCustomerOrderAdress(Id).subscribe(
      data => {
        if (data) {
          this.customerOrderAdress = data;
          if (this.customerOrderAdress.shippingCountryID) {
            this.GetShippingStatesByCountry({
              target: {
                value: this.customerOrderAdress.shippingCountryID
              }
            });
            if (this.customerOrderAdress.shippingStateID) {
              this.GetShippingCitesByState({
                target: {
                  value: this.customerOrderAdress.shippingStateID
                }
              });
            }
            else {
              this.customerOrderAdress.shippingCity = "";
            }
          }
          else {
            this.customerOrderAdress.shippingCountryID = 0;
          }

          if (this.customerOrderAdress.billingCountryID) {
            this.GetBillingStatesByCountry({
              target: {
                value: this.customerOrderAdress.billingCountryID
              }
            });
            if (this.customerOrderAdress.billingStateID) {
              this.GetBillingCitesByState({
                target: {
                  value: this.customerOrderAdress.billingStateID
                }
              });
            }
            else {
              this.customerOrderAdress.billingCity = "";
            }
          }
          else {
            this.customerOrderAdress.billingCountryID = "";
          }
          this.modalRef = this.modalService.show(customerTemplate, this.config);
        }
      });
  }
  GetBillingStatesByCountry($event) {
    this.stateService.getStateByCountryId($event.target.value).subscribe(
      data => {
        this.mainStateList = data;
        if (this.customerOrderAdress.billingStateID == null || this.customerOrderAdress.billingStateID == "") {
          this.customerOrderAdress.billingStateID = "";
        }
      });
  }

  GetShippingStatesByCountry($event) {
    this.stateService.getStateByCountryId($event.target.value).subscribe(
      data => {
        this.mailingStateList = data;
        if (this.customerOrderAdress.shippingStateID == null || this.customerOrderAdress.shippingStateID == 0) {
          this.customerOrderAdress.shippingStateID = 0;
        }
      });
  }
  GetBillingCitesByState($event) {
    var value = $event.target.value;
    if (value == undefined || value == "") value = 0;
    this.stateService.GetCitesByState(value).subscribe(
      data => {
        this.mainCityList = data;
        if (this.customerOrderAdress.billingCity == null || this.customerOrderAdress.billingCity == "0") {
          this.customerOrderAdress.billingCity = "";
        }
      });
  }

  GetShippingCitesByState($event) {
    var value = $event.target.value;
    if (value == undefined || value == "") value = 0;
    this.stateService.GetCitesByState(value).subscribe(
      data => {
        this.mailingCityList = data;
        if (this.customerOrderAdress.shippingCity == null || this.customerOrderAdress.shippingCity == "0") {
          this.customerOrderAdress.shippingCity = "";
        }
      });
  }
  UpdateCustomerInfo() {
    if (this.customerOrderAdress.billingCountryID == "") {
      this.customerOrderAdress.billingCountryID = "0";
    }
    this.orderService.UpdateCustomerOrderAdress(this.customerOrderAdress).subscribe(
      data => {
        if (data) {
          this.modalRef.hide();
          this.toastr.success('Customer Adress has been Updated. ', 'Success');
          if (this._avRoute.snapshot.params["id"]) {
            this.GetOrderDetail(this._avRoute.snapshot.params["id"]);
          }
        }
      });
  }

  onSearch(searchText: string) {

    this.productName = "";
    var length = 0;
    try {
      length = searchText.length;
    } catch (e) {
      this.showSuggestions = false;
      return;
    }
    if (length > 0) {
      this.ProductService.ProductSuggestionsByVendor(searchText, this.ProductToAdd.vendorID).subscribe(
        data => {
          this.vendorProductList = data;
          
          if (this.vendorProductList.length > 0) {
            this.showSuggestions = true;
          }
        });
    }
    else {
      this.vendorProductList = [];
      this.showSuggestions = false;
    }
  }

  //for print of div 
  oldprint(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    this.orderDetailPrintComponent = '';
    for (var i = 0; i < this.orderDetail.orderDetails.length; i++) {
      if (this.orderDetail.orderDetails[i].purchaseOrderStatusID != 4
        && this.orderDetail.orderDetails[i].purchaseOrderStatusID != 5
      ) {
        this.product = new Product();
        this.product = this.ProductList.filter(d => d.productID == this.orderDetail.orderDetails[i].productID)[0];
        this.orderDetailPrintComponent += '<tr><td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;">' + this.product.name + ' <br /> <small>' + this.product.sku + '</small></td ><td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;">' + this.orderDetail.orderDetails[i].productArrtibuteFields + ' <br /> <small>' + this.orderDetail.orderDetails[i].productArrtibuteValue + '</small></td ><td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"> ' + this.orderDetail.orderDetails[i].quantity + '</td><td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"> ' + this.orderDetail.orderDetails[i].price + '</td><td style = "text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"> ' + this.orderDetail.orderDetails[i].price * this.orderDetail.orderDetails[i].quantity + '</td></tr>';
      }
    }
    if (this.orderDetail.order.couponAmount > 0) {
      this.discountRow = '<tr> <td></td><td></td> <td></td><td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"><strong>Discount</strong></td> <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;">-' + this.orderDetail.order.couponAmount + '</td></tr>';
    }
    if (this.orderDetail.order.shippingAddress == null) this.orderDetail.order.shippingAddress = "";
    if (this.orderDetail.order.shippingAddress == null) this.orderDetail.order.shippingAddress = "";
    if (this.orderDetail.customer.mobilePhone == null) this.orderDetail.customer.mobilePhone = "";

    //popupWin.document.write(`${printContents}`
    //);
    popupWin.document.write(`<!DOCTYPE html>
<html xmlns="http://www.w3.org/1999/xhtml">
    <head>
        <meta charset="utf-8"/>
        <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"/>
        <title>Order Invoice</title>
    </head>
    <body onload="window.print();window.close()" style="padding:0;margin:0;font-family:Arial;font-size:12px;color:#000; line-height:20px;">
        <div style="width:900px;margin:auto;">
            <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr><td colspan="2">&nbsp;</td></tr>
                <tr>
                    <td width="70%">
                       <img src="/Images/WebsiteImages/WebsiteLogo.jpg" width="250" alt=""/></td>
                    <td>
                        <!-- <strong>Incartoo.com</strong><br/> -->
                        <p>Office # 17 / N Block,<br/>
                             Main Blvd,
Johar Town, Lahore Pakistan<br/>
                            info@arhamsoft.com<br/>
                            incartoo.com<br/>
                            Phone # +92.34.59666526
                        </p>
                    </td>
                </tr>
                <tr><td colspan="2">&nbsp;</td></tr>
                <tr>
                    <td>
                      <h1>INVOICE</h1>
                        <p>
                            ${this.orderDetail.customer.firstName} ${this.orderDetail.customer.lastName}<br/>
                        
                            ${this.orderDetail.order.shippingAddress}<br/>
                            ${this.orderDetail.order.shippingCity}<br/>
                            ${this.orderDetail.shippingState}<br/>
                            ${this.orderDetail.shippingCountry}<br/>
                            <a href="${this.orderDetail.customer.email}">${this.orderDetail.customer.email}</a><br/>
                            ${this.orderDetail.customer.mobilePhone}<br/>
                        </p>
                    </td>
                    <td valign="top">
                        <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr>
                                <td>Order Number:</td>
                                <td>${this.orderDetail.order.orderID}</td>
                            </tr>
                            <tr>
                                <td>Order Date:</td>
                                <td>${this.orderDetail.order.orderDate}</td>
                            </tr>
                            <tr>
                                <td>Payment Method:</td>
                                <td>${this.orderDetail.strPaymentMethod}</td>
                            </tr>
                            <tr>
                                <td>Shipping Method:</td>
                                <td>${this.orderDetail.strShippingMethod}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr><td colspan="2" style="height:30px;">&nbsp;</td></tr>
                <tr>
                    <td colspan="2">
                        <table width="100%" cellpadding="0" cellspacing="0" border="0" align="left" b>
                            <tr>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Product</th>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Attributes</th>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Quantity</th>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Unit Price</th>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Price Total</th>
                            </tr>
                            ${this.orderDetailPrintComponent}
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"><strong>Subtotal</strong></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;">${this.subTotal/* this.orderDetail.order.subTotal*/}</td>
                            </tr>
                            ${this.discountRow}
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 2px #000;"><strong>Shipping</strong></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 2px #000;">${this.orderDetail.order.shippingPrice}</td>
                            </tr>
                            <tr>
                                <td></td>
                                 <td></td>
                                  <td></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 2px #000;"><strong>Total</strong></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 2px #000;">Rs <strong>${this.total}</strong></td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr><td colspan="2" style="height:30px;">&nbsp;</td></tr>
            </table>
        </div>
    </body>
</html>
`);
    popupWin.document.close();
  }


       print(): void {
        var order = this.orderDetail;
          this.orderDetailPrintComponent = '';
          for (var i = 0; i < order.orderDetails.length; i++) {
            if (order.orderDetails[i].purchaseOrderStatusID != 4
              && order.orderDetails[i].purchaseOrderStatusID != 5
            ) {
              this.product = new Product();
              this.product = order.products.filter(d => d.productID == order.orderDetails[i].productID)[0];
              this.orderDetailPrintComponent += '<tr><td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;">' + this.product.name + ' <br /> <small>' + this.product.sku + '</small></td ><td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;">' + this.orderDetail.orderDetails[i].productArrtibuteFields + ' <br /> <small>' + this.orderDetail.orderDetails[i].productArrtibuteValue + '</small></td ><td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"> ' + order.orderDetails[i].quantity + '</td><td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"> ' + order.orderDetails[i].price + '</td><td style = "text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"> ' + order.orderDetails[i].price * order.orderDetails[i].quantity + '</td></tr>';
            }
          }
          if (order.order.couponAmount > 0) {
            this.discountRow = '<tr><td></td><td></td><td></td> <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"><strong>Discount</strong></td> <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;">-' + order.order.couponAmount + '</td></tr>';
          }
          if (order.order.shippingAddress == null) order.order.shippingAddress = "";
          if (order.order.shippingAddress == null) order.order.shippingAddress = "";
          if (order.customer.mobilePhone == null) order.customer.mobilePhone = "";

          //popupWin.document.write(`${printContents}`
          //);
          this.subTotal = 0;
          this.total = 0;
         this.paymentSaleAmount = 0;
         this.calculateSubtotalPrint(order);
        var  text = `
        <div style="width:900px;margin:auto;">
            <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr><td colspan="2">&nbsp;</td></tr>
                <tr>
                    <td width="70%">
                       <img src="/Images/WebsiteImages/WebsiteLogo.jpg" width="250" alt=""/></td>
                    <td>
                        <!-- <strong>Incartoo.com</strong><br/> -->
                        <p>Office # 17 / N Block,<br/>
                            Main Blvd, Johar Town, Lahore Pakistan<br/>
                            info@arhamsoft.com<br/>
                            incartoo.com<br/>
                            Phone # +92.34.59666526
                        </p>
                    </td>
                </tr>
                <tr><td colspan="2">&nbsp;</td></tr>
                <tr>
                    <td>
                      <h1>INVOICE</h1>
                        <p>
                            ${order.customer.firstName} ${order.customer.lastName}<br/>
                           <strong class="address-col-heading">Shipping Address</strong>
                            ${order.order.shippingAddress}<br/>
                            ${order.order.shippingCity}<br/>
                            ${order.shippingState}<br/>
                            ${order.shippingCountry}<br/>
                            <a href="${order.customer.email}">${order.customer.email}</a><br/>
                            ${order.customer.mobilePhone}<br/>
                           <strong class="address-col-heading">Billing Address</strong>
                            ${order.customer.mainAddress}<br/>
                            ${order.order.shippingCity}<br/>
                            ${order.shippingState}<br/>
                            ${order.shippingCountry}<br/>
                        </p>
                    </td>
                    <td valign="top">
                        <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr>
                                <td>Order Number:</td>
                                <td>${order.order.orderID}</td>
                            </tr>
                            <tr>
                                <td>Order Date:</td>
                                <td>${order.order.orderDate}</td>
                            </tr>
                            <tr>
                                <td>Payment Method:</td>
                                <td>${order.strPaymentMethod}</td>
                            </tr>
                            <tr>
                                <td>Shipping Method:</td>
                                <td>${order.strShippingMethod}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr><td colspan="2" style="height:30px;">&nbsp;</td></tr>
                <tr>
                    <td colspan="2">
                        <table width="100%" cellpadding="0" cellspacing="0" border="0" align="left" b>
                            <tr>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Product</th>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Attributes</th>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Quantity</th>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Unit Price</th>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Price Total</th>
                            </tr>
                            ${this.orderDetailPrintComponent}
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"><strong>Subtotal</strong></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;">${(this.subTotal/* this.orderDetail.order.subTotal*/).toFixed(2)}</td>
                            </tr>
                            ${this.discountRow}
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 2px #000;"><strong>Shipping</strong></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 2px #000;">${order.order.shippingPrice}</td>
                            </tr>
                            <tr>
                                <td></td>
                                 <td></td>
                                <td></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 2px #000;"><strong>Total</strong></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 2px #000;">Rs <strong>${(this.total).toFixed(2)}</strong></td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr><td colspan="2" style="height:30px;">&nbsp;</td></tr>
            </table>
        </div>

`;

            let printContents, popupWin;
            printContents = document.getElementById('print-section').innerHTML;
            popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
            popupWin.document.open();

            popupWin.document.write(`<!DOCTYPE html>
<html xmlns="http://www.w3.org/1999/xhtml">
    <head>
        <meta charset="utf-8"/>
        <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"/>
        <title>Order Invoice</title>

    </head>
    <body  onload="window.print();window.close()" style="padding:0;margin:0;font-family:Arial;font-size:12px;color:#000; line-height:20px;">
`+ text + `
    </body>
</html>
`);
            popupWin.document.close();

         


}
  calculateSubtotalPrint(data: OrderViewModel) {
    this.subTotal = 0;
    for (var i = 0; i < data.orderDetails.length; i++) {
      if (data.orderDetails[i].purchaseOrderStatusID != 4
        && data.orderDetails[i].purchaseOrderStatusID != 5
      ) {

        //checking if we can add
           if (data.orderDetails[i].salePrice > 0) {
            this.subTotal += data.orderDetails[i].salePrice * data.orderDetails[i].quantity;
          }
          else {
            this.subTotal += data.orderDetails[i].price * data.orderDetails[i].quantity;
          }
      }
    }
    if (data.order.couponAmount == null || data.order.couponAmount == undefined) {
      data.order.couponAmount = 0;
    }
    this.paymentSaleAmount = data.order.paymentSaleAmount;
    this.total = (this.subTotal - data.order.couponAmount) + data.order.shippingPrice - (data.order.paymentSaleAmount);

  }


}



// WEBPACK FOOTER //
// ./src/app/order-components/order-detail/order-detail.component.ts